import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { first, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const authorizedRoles = route.data.authorizedRoles;
    // const test = this.authService.$user.value.roles.some(r => authorizedRoles.includes(r));

    return this.authService.getAuth().pipe(
      map(a => a.roles.some(r => authorizedRoles.includes(r))),
      tap(a => {
        // console.log(a);
        if (!a) {
          window.location.href = '/';
          this.router.navigate(['/']);
        }
      })
    );
  }

  constructor(private authService: AuthService, private router: Router) {}
}
